const Robot = ({ className }: { className?: string }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_150_1829)">
        <path
          opacity="0.2"
          d="M25 7H7C6.20435 7 5.44129 7.31607 4.87868 7.87868C4.31607 8.44129 4 9.20435 4 10V24C4 24.7956 4.31607 25.5587 4.87868 26.1213C5.44129 26.6839 6.20435 27 7 27H25C25.7956 27 26.5587 26.6839 27.1213 26.1213C27.6839 25.5587 28 24.7956 28 24V10C28 9.20435 27.6839 8.44129 27.1213 7.87868C26.5587 7.31607 25.7956 7 25 7ZM20.5 23H11.5C10.837 23 10.2011 22.7366 9.73223 22.2678C9.26339 21.7989 9 21.163 9 20.5C9 19.837 9.26339 19.2011 9.73223 18.7322C10.2011 18.2634 10.837 18 11.5 18H20.5C21.163 18 21.7989 18.2634 22.2678 18.7322C22.7366 19.2011 23 19.837 23 20.5C23 21.163 22.7366 21.7989 22.2678 22.2678C21.7989 22.7366 21.163 23 20.5 23Z"
          fill="white"
        />
        <path
          d="M25 7H7C5.34315 7 4 8.34315 4 10V24C4 25.6569 5.34315 27 7 27H25C26.6569 27 28 25.6569 28 24V10C28 8.34315 26.6569 7 25 7Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 7V2"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 15C11.3284 15 12 14.3284 12 13.5C12 12.6716 11.3284 12 10.5 12C9.67157 12 9 12.6716 9 13.5C9 14.3284 9.67157 15 10.5 15Z"
          fill="white"
        />
        <path
          d="M21.5 15C22.3284 15 23 14.3284 23 13.5C23 12.6716 22.3284 12 21.5 12C20.6716 12 20 12.6716 20 13.5C20 14.3284 20.6716 15 21.5 15Z"
          fill="white"
        />
        <path
          d="M20.5 18H11.5C10.1193 18 9 19.1193 9 20.5C9 21.8807 10.1193 23 11.5 23H20.5C21.8807 23 23 21.8807 23 20.5C23 19.1193 21.8807 18 20.5 18Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 18V23"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.5 18V23"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_150_1829">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Robot;
